import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { OceanPlaceContent } from "../components/OceanPlaceContent.mjs";
import { trackEvent, trackRestaurantMapClick } from "../utils/analytics";
import "./OceanPlacePage.scss";

export default function OceanPlacePage({ collection }) {
  const { slug } = useParams();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  useEffect(() => {
    const previousLang = document.documentElement.lang;
    document.documentElement.lang = "ja";
    return () => { document.documentElement.lang = previousLang; };
  }, []);
  useEffect(() => {
    setQuery("");
    setCategory("");
  }, [collection]);
  const onAction = (action, place) => {
    const params = { place_name: place.name, place_slug: place.slug, placement: "ocean_place_detail" };
    trackEvent("place_detail_action", { ...params, action });
    if (action === "map" && place.collection === "restaurants") {
      trackRestaurantMapClick({ restaurant_name: place.name, restaurant_id: place.slug, placement: "ocean_place_detail" });
    } else if (action === "map") {
      trackEvent("map_navigate_click", { ...params, spot_name: place.name });
    }
  };
  return <OceanPlaceContent collection={collection} slug={slug} query={query} category={category}
    onQueryChange={(event) => setQuery(event.target.value)} onCategoryChange={setCategory} onAction={onAction} />;
}
